import { AcLockObject } from '@utils/ac-lock-object';

export const ROLES = AcLockObject({
	USER: 'user',
	MANAGER: 'manager',
	ADMIN: 'admin',
});
